import React, {useState, useRef, useEffect} from "react";
import {actions, Control} from "react-redux-form";
import {Card, Col, Row, Table} from "reactstrap";
import {compose, withHandlers} from "recompose";
import shortid from "shortid";
import {Trans} from "react-i18next";
import {getStatus, FormGroup, onMount, Page, required, withLocalForm, withReload,} from "components/common";
import { formatDate as formatedDate } from "services/util";
import {
  Payment,
  LineItemsView,
  withContactSearch,
  withDocumentRenderer,
  withOptions,
  withXeroErrors,
  Attachments,
} from "components";
import {BillDocument, SmallInvoiceDocument} from "components/documents";
import {withOrganisationContextConsumer} from "contexts/OrganisationContext";
import BackButton from "components/refactoring/BackButton";
import { Link } from "react-router-dom";
import HistoryComponent from "components/ShowHistoryComponent";


const ShareCell = withDocumentRenderer({
  onDownload: () => (getDocument, item) =>
    getDocument(
      {
        item,
      },
      `Bill_${item.InvoiceNumber}.pdf`,
    ),
})(({ DocumentRenderer, ShareDocument, i, selectedOrganisation }) => (
  <td className="text-end text-left">
    <ShareDocument item={i} wtsp={true}/> 
    <DocumentRenderer component={BillDocument} selectedOrganisation={selectedOrganisation}/> 
  </td>
));

export const ViewBill = ({
  item,
  LocalForm,
  onSubmit,
  xero,
  dispatch,
  handlePaymentAdded,
  handleAttachmentsChanged,
  XeroErrors,
  organisation,
  DocumentRenderer,
  DownloadDocument,
  EmailDocument,
  history,
  t,
  invHistory,
  BillOptions,
  selectedOrganisation,
  prepayments,
  reload,
}) => {

  const historyItem = invHistory.HistoryRecords;

  const [isPaymentVisible, setPaymentVisibility] = useState(false);

  const togglePaymentVisibility = () => {
    setPaymentVisibility(!isPaymentVisible);
  };
  
  const editLink = () => {
    const { InvoiceID } = item;

    history.push(`/purchases/bills/edit/${InvoiceID}`)
  };

  const SpanColor = ({ children }) => {
    const colorInheritStyle = {
      color: '#525f7f',
      fontSize: "1.2em",
    };
  
    return <span style={colorInheritStyle}>{children}</span>;
  };

  const cStyle = {
    status: {
      style: { fontWeight: 'bold', fontSize: '1.3em', color: '#72B566'},
    },
    common: {
      className: "pt-3 pb-3",
      xs: false,
      md: 3,
    },
  };


  const pageTakeOver = useRef(null);

  useEffect(() => {
    if (isPaymentVisible && pageTakeOver.current) {
      setTimeout(() => {
        const fullPageHeight = document.body.scrollHeight;
        window.scrollTo({
          top: fullPageHeight,
          behavior: 'smooth',
        });
      }, 200);
    }
  }, [isPaymentVisible]);

  return (
    <div className="nw-invoiceStyle">
    <Page
      title={
        item.InvoiceID
          ? t(`Bill {{ InvoiceNumber }}`, {
              InvoiceNumber: item.InvoiceNumber,
            })
          : ''
      }
      translate={false}
    >
      <BackButton />
      <XeroErrors />
      {item && item.LineItems ? <>
      <DocumentRenderer component={BillDocument} />
      <div className="d-flex align-items-center" style={{paddingBottom:20}}>
        {item.SentToContact && (
          <div className="text-success small">
            <span className="fa fa-check mr-1" /> <Trans>Sent to contact</Trans>
          </div>
        )}
        <div className="mx-auto" />
        {!!(item.InvoiceID && item.Attachments) && (
          <Attachments
            xero={xero}
            hideIncludeOnline
            onAttachmentsChanged={handleAttachmentsChanged}
            baseUrl={`invoices/${item.InvoiceID}`}  
            attachments={item.Attachments}
          />
        )}
        {!!item.InvoiceID && <DownloadDocument className="mr-2" />}
        {!!item.InvoiceID && <EmailDocument type="BILLS" item={item} />}
        <div className="mx-1" />
        {!!item.InvoiceID && <ShareCell i={item} selectedOrganisation={selectedOrganisation}/>}
        {(item.Status === "PAID" || item.Status === "AUTHORISED") ? (
            <>
                <div className="mx-1" />
                <BillOptions />
            </>
        ) : (
            <button
                type="button"
                className="btn-sm btn btn-primary"
                onClick={editLink}
            >
                Edit Bill
            </button>
        )}
        {item.Status === "AUTHORISED" && (
          <button 
            type="button"
            className="btn-sm btn btn-primary"
            onClick={togglePaymentVisibility}>
            {isPaymentVisible ? t('Hide Payment') : t('Add Payment')}
          </button>
        )}
      </div>
      <LocalForm className="mt-3 custom-form inv-table">
        <Row>
          <Col {...cStyle.common}>
            <FormGroup label="From" model=".Name" >
              <Link to={`/contacts/view/${item?.Contact?.ContactID}`} {...cStyle.status}>
                  {item.Contact.Name}
              </Link>
            </FormGroup>
          </Col>
          <Col {...cStyle.common}>
            <FormGroup label="Status">
              <SpanColor>{getStatus(item.Status)}</SpanColor>
            </FormGroup>
          </Col>
          <Col {...cStyle.common}>
            <FormGroup label="Date" model=".Date">
            <SpanColor>{formatedDate(item.Date) || "---"}</SpanColor>
            </FormGroup>
          </Col>
          <Col {...cStyle.common}>
            <FormGroup label="Due Date" model=".DueDate" >
            <SpanColor>{formatedDate(item.DueDate)|| "---"}</SpanColor>
              </FormGroup>
            </Col>
          <Col {...cStyle.common}>
            <FormGroup
              label="Planned Payment Date"
              model=".PlannedPaymentDate"
            ><SpanColor>{formatedDate(item.PlannedPaymentDate) || "---"}</SpanColor>
            </FormGroup>
          </Col>
          <Col {...cStyle.common}>
            <FormGroup label="Reference" model=".InvoiceNumber">
            <SpanColor>{item.InvoiceNumber || "---"}</SpanColor>
            </FormGroup>
          </Col>
          <Col {...cStyle.common}>
            <FormGroup label="Note" model=".Reference">
            <SpanColor>{item.Reference || "---"}</SpanColor>
            </FormGroup>
          </Col>
        </Row>
        <hr />
        <LineItemsView
          organisation={organisation}
          item={item}
          includeDiscount={item.Type === 'ACCPAY'}
          dispatch={dispatch}
          xero={xero}
          hideAddLines={true}
          hideAccountAndTax={false}
          invoiceType= "Bill"
          prepayments={prepayments}
          reload={reload}
        />
      <HistoryComponent historyItem={historyItem} type="Bill" t={t}/>
      </LocalForm> 
      </>
      : 
      <div className="text-center" style={{fontSize:"1.3em"}}><p><Trans>The ID was not found, please make sure to check once and try again.</Trans></p></div>
      }
    </Page>
    {isPaymentVisible && (
      <div ref={pageTakeOver} className="centered-container">
        <Payment
          invoice={item}
          organisation={organisation}
          onPaymentAdded={handlePaymentAdded}
          xero={xero}
        />
      </div>
    )}
  </div>
);
};

const enhance = compose(
  withOrganisationContextConsumer,
  withReload(),
  onMount(({ match, xero, location, fetchOrganisation }) => async () => {
    const { id } = match.params;
    const item = await xero
      .get(`invoices/${match.params.id}`)
      .get("data")
      .then((item) => ({
        ...item,
        LineItems: item?.LineItems?.map((i) => ({
          ...i,
          _id: shortid(),
        })),
      }));
    const invHistory = await xero
      .get(`invoices/${match.params.id}/History`)
      .get("data")
      .then((invHistory) => ({
        ...invHistory,
      }));

      let remainingCredit = 0;
      let prepayments = [];
      if (item?.Status === 'AUTHORISED' && ['ACCREC', 'ACCPAY'].includes(item?.Type)) {
        const prepayment_type = item?.Type === 'ACCREC' ? 'RECEIVE-PREPAYMENT' : 'SPEND-PREPAYMENT';
        prepayments = await xero
          .get(`prepayments`,
            {
              params: {
                raw: `Contact.ContactID=GUID("${item?.Contact?.ContactID}") AND Status="AUTHORISED" AND TYPE="${prepayment_type}"`,
              },
            }
          )
          .get("data")
        remainingCredit = prepayments?.reduce((total, prepayment) => total + prepayment.RemainingCredit, 0);
      }

    const organisation = await fetchOrganisation();
    return {
      item: {...item, RemainingCredit: remainingCredit},
      prepayments,
      invHistory,
      organisation,
    };
  }),
  withLocalForm({
    initialState: ({ item }) => item,
    stateKey: "item",
    formKey: "form",
  }),
  withContactSearch(),
  withXeroErrors(),
  withHandlers({
    handleAttachmentsChanged:
      ({ xero, match, dispatch }) =>
      () => {
        xero
          .get(`invoices/${match.params.id}/attachments`)
          .get("data")
          .tap((d) => dispatch(actions.change("local.Attachments", d)));
      },
      handlePaymentAdded:
      ({ reload }) =>
      () => {
        reload();
      },
  }),
  withOptions(),
  withDocumentRenderer({
    onDownload:
      ({ item, xero }) =>
      (getDocument) =>
        getDocument(
          {
            item,
          },
          `bill_${item.InvoiceNumber}.pdf`
        ),
    type: "BILLS",
  })
);

export default enhance(ViewBill);